import {LoomDeletePolicy} from '../loom-delete-policy/loom-delete-policy.enum';

export class LoomScheduleSettings {
  private _deletePolicy: LoomDeletePolicy;
  private _deletePolicyTimePeriodInDays?: number;
  private _scheduleFileAutoDeleteAfterStartOnLoom: boolean;
  private _scheduleOnlyStartFromQueue: boolean;

  public constructor(deletePolicy: LoomDeletePolicy, deletePolicyTimePeriodInDays: number | null, scheduleFileAutoDeleteAfterStartOnLoom: boolean, scheduleOnlyStartFromQueue: boolean) {
    this._deletePolicy = deletePolicy;
    this._deletePolicyTimePeriodInDays = deletePolicyTimePeriodInDays;
    this._scheduleFileAutoDeleteAfterStartOnLoom = scheduleFileAutoDeleteAfterStartOnLoom;
    this._scheduleOnlyStartFromQueue = scheduleOnlyStartFromQueue;
  }

  public get deletePolicy(): LoomDeletePolicy {
    return this._deletePolicy;
  }

  public set deletePolicy(value: LoomDeletePolicy) {
    this._deletePolicy = value;
  }

  public get deletePolicyTimePeriodInDays(): number | undefined {
    return this._deletePolicyTimePeriodInDays;
  }

  public set deletePolicyTimePeriodInDays(value: number | undefined) {
    this._deletePolicyTimePeriodInDays = value;
  }

  public get scheduleFileAutoDeleteAfterStartOnLoom(): boolean {
    return this._scheduleFileAutoDeleteAfterStartOnLoom;
  }

  public set scheduleFileAutoDeleteAfterStartOnLoom(value: boolean) {
    this._scheduleFileAutoDeleteAfterStartOnLoom = value;
  }

  public get scheduleOnlyStartFromQueue(): boolean {
    return this._scheduleOnlyStartFromQueue;
  }

  public set scheduleOnlyStartFromQueue(value: boolean) {
    this._scheduleOnlyStartFromQueue = value;
  }

  public toJSON(): JSON {
    return {
      deletePolicy: LoomDeletePolicy[this._deletePolicy],
      deletePolicyTimePeriodInDays: this._deletePolicyTimePeriodInDays,
      scheduleFileAutoDeleteAfterStartOnLoom: this._scheduleFileAutoDeleteAfterStartOnLoom,
      scheduleOnlyStartFromQueue: this._scheduleOnlyStartFromQueue
    } as any as JSON;
  }

  public static fromJSON(json: any): LoomScheduleSettings {
    return new LoomScheduleSettings(LoomDeletePolicy[json.deletePolicy as string], json.deletePolicyTimePeriodInDays, json.scheduleFileAutoDeleteAfterStartOnLoom, json.scheduleOnlyStartFromQueue);
  }
}
